
import NrSelect from '@nextrequestco/components/src/components/NrSelect/nr-select.vue'
import MessageBox from '@nextrequestco/components/src/components/MessageBox/MessageBox.vue'
import NrEditor from '@nextrequestco/components/src/components/NrEditor/nr-editor.vue'
import NrFormInput from '@nextrequestco/components/src/components/NrFormInput/nr-form-input.vue'
import NrFormLabel from '@nextrequestco/components/src/components/form-elements/nr-form-label.vue'
import { MessageTemplates } from './types/message_boxes'
import { mapActions, mapState } from 'vuex'
import throttle from 'lodash/throttle'

export default {
  name: 'ExternalMessageModal',
  components: {
    MessageBox,
    NrFormInput,
    'nr-editor': NrEditor,
    NrFormLabel,
    NrSelect
  },
  data() {
    return {
      selectedMessageTemplates: [],
      message: '',
      messageRequired: false
    }
  },
  computed: {
    ...mapState('request_show', [
      'displayMsgBox',
      'currentAction',
      'request',
      'dataOptions',
      'dataFetchState'
    ]),
    ...mapState(['account']),

    requesterEmailAvailable(): boolean {
      return this.request.requester.email !== 'Email Not Available'
    },

    canReadStaffOnlyItems(): boolean {
      return this.$ability.can('read', 'staff_only_items')
    },

    filteredMessageTemplates(): Array<MessageTemplates> {
      return this.dataOptions.message_templates.map(
        (temp: MessageTemplates) => ({
          value: temp.id,
          label: temp.message_template_name,
          description: temp.message_template_description
        })
      )
    },

    modalTitle(): string {
      return this.canReadStaffOnlyItems
        ? `Message to ${this.request.requester.name}`
        : `Message to ${this.account.name}`
    }
  },
  methods: {
    ...mapActions('request_show', [
      'submitExternalMessage',
      'setDisplayMsgBox',
      'fetchDataOptions'
    ]),

    loadMoreMessageTemplates: throttle(function () {
      this.fetchDataOptions({
        searchText: this.dataFetchState.message_templates.search_text,
        dataType: 'message_templates'
      })
    }, 400),

    disableSubmitMsg(): boolean {
      if (this.canReadStaffOnlyItems && this.requesterEmailAvailable) {
        return !(this.messageRequired && this.message.length)
      } else {
        return !this.message.length
      }
    },

    setMessageTemplate(reset = false, templates = []): void {
      if (reset) {
        this.message = this.selectedMessageTemplates
          .map((temp: { description: string }) => temp.description)
          .join('')
      } else {
        this.message = this.message + templates.pop()?.description
      }
    },

    searchMessageTemplates: throttle(function (searchText = '') {
      this.fetchDataOptions({
        searchText,
        dataType: 'message_templates'
      })
    }, 400),

    handleCancelMessage(): void {
      this.message = ''
      this.selectedMessageTemplates = []
      this.messageRequired = false
      setTimeout(() => {
        this.setDisplayMsgBox(false)
      }, 100)
    },

    handleSubmitMessage(): void {
      this.submitExternalMessage({
        note_text: this.message,
        note_type: 'requester',
        state: 'requester',
        request_id: this.request.pretty_id,
        required: this.messageRequired,
        message_template_ids: this.selectedMessageTemplates.map(
          (template: { value: number }) => template.value
        )
      }).then(() => {
        this.handleCancelMessage()
      })
    }
  }
}
